/* Present the subscription app in the storefront language; leave its selection and pricing controller intact. */
(() => {
  const start = () => document.querySelectorAll('.j-product--package').forEach((root) => {
    const refresh = () => {
      const widget = root.querySelector('.sealsubs-container');
      if (!widget) return;
      const heading = widget.querySelector('.sls-purchase-options-label');
      if (heading && heading.textContent === 'Kauf Optionen') heading.textContent = 'Lieferung wählen';
      widget.querySelectorAll('.sls-selling-plan-group-name').forEach((label) => {
        const text = label.firstChild;
        if (!text || text.nodeType !== Node.TEXT_NODE) return;
        const clean = text.textContent.trim();
        if (clean === 'Einmal Kauf') text.textContent = 'Einmalig';
        if (clean === '2 Monate') text.textContent = 'Alle 2 Monate ';
      });
      widget.querySelectorAll('[aria-label="Einmal Kauf"]').forEach((radio) => radio.setAttribute('aria-label', 'Einmalig'));
      widget.querySelectorAll('[aria-label="2 Monate"]').forEach((radio) => radio.setAttribute('aria-label', 'Alle 2 Monate'));
      widget.querySelectorAll('.sls-savings-badge').forEach((badge) => {
        const text = badge.firstChild;
        if (text?.nodeType === Node.TEXT_NODE && /SAVE/.test(text.textContent)) text.textContent = text.textContent.replace('SAVE', 'Spare');
      });
      const active = widget.querySelector('.sls-option-container.sls-active');
      const selected = active?.querySelector('input.sls-option');
      let note = widget.querySelector('.j-subscription-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'j-subscription-note';
        note.setAttribute('aria-live', 'polite');
        widget.querySelector('.sls-purchase-options-container')?.after(note);
      }
      const interval = active?.querySelector('[role="radio"]')?.getAttribute('aria-label') || '';
      const message = selected?.dataset.type === 'one_time' ? 'Einmaliger Kauf. Kein Abo.' : `Preis je Lieferung · ${interval}. Wiederkehrend, änderbar und kündbar.`;
      if (note.textContent !== message) note.textContent = message;
    };
    refresh();
    new MutationObserver(refresh).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
